import { render, staticRenderFns } from "./ProfileVlanRule.vue?vue&type=template&id=15821255&"
import script from "./ProfileVlanRule.vue?vue&type=script&lang=js&"
export * from "./ProfileVlanRule.vue?vue&type=script&lang=js&"
import style0 from "./ProfileVlanRule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports